import Footer from '../components/footer';
import Menu from '../components/menu';
import franceMap from '../assets/images/france-map.jpg';
import logoPadel from '../assets/images/logo-padel.png';
import logoJoueur from '../assets/images/logo-joueur.png';
import logoCloche from '../assets/images/logo-cloche.png';
import joueurPadel1 from '../assets/images/joueur-padel1.png';
import carteFrance from '../assets/images/carte-france.png';
import imgPartenaire from '../assets/images/img-trouver-partenaire.png';
import imgNotif from '../assets/images/img-notification.png';
import imgTournoiDispo from '../assets/images/img-tournoi-dispo.png';
import BulleRaquette from '../assets/images/img-bulle-raquette.png'
import padelCourt from '../assets/images/raquette.png';
import imgBanniereBalle from '../assets/images/img-banniere-balle.png';
import imgDouble from '../assets/images/padel-tennis-doubles.png';
import imgBulle1 from '../assets/images/bulle-joueur-1.png';
import imgBulle2 from '../assets/images/bulle-joueur-2.png';
import { link } from 'fs';
import { useEffect, useState } from 'react';

const HeroSection: React.FC = () => {
    return (
      <section
        className="relative h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${padelCourt})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white">
          <h1 className="text-5xl font-bold mb-4">Accédez à tous les tournois de padel de France</h1>          
          <a
            href="tournois"
            className="px-8 py-4 bg-orange-300 text-white text-lg font-medium rounded-lg hover:bg-orange-400 transition"
          >
            Découvrez les tournois
          </a>
        </div>
      </section>
    );
  };


/* Erika se dit que si la carte n'est pas interactive, cela ne sert à rien de la mettre en place
/*const MapSection: React.FC = () => {
    return (
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Explorez les tournois par région</h2>          
            <div className="flex grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center text-center ">
              <img className="hidden sm:block"
                src={joueurPadel1}
              />
              <img className=""
                src={carteFrance}
              />
            </div>
        </div>
      </section>
    );
  };*/

  
  const PremiumSection: React.FC = () => {
    return (
      <section className="py-16 bg-orange-300 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-4">Rejoignez TournoisPadel Premium</h2>
        <p className="text-lg mb-6">
          Ne ratez plus aucun tournoi, profitez de notifications et trouvez des partenaires en passant premium
        </p>
        <div className="bg-white text-black p-6 rounded-lg shadow-lg mb-6">
          <h3 className="text-2xl font-bold mb-2">Créez votre compte gratuitement</h3>
          <p className="text-lg">et profitez des avantages premium pendant 7 jours</p>
        </div>
        <a
          href="/signup"
          className="px-8 py-4 text-black font-medium rounded-lg bg-white hover:bg-gray-300 transition"
        >
          Créer un compte
        </a>
      </div>
    </section>
    );
  };

  const PartageSection: React.FC = () => {
    return (
      <section className="py-16 ">
        <div className="container mx-auto px-4 text-center">
          
            <div className="flex flex-col md:flex-row items-center gap-8">
            <div              
              className="p-4 rounded-lg shadow-md bg-cover bg-center h-96  w-96"
              style={{ backgroundImage: `url(${BulleRaquette})`, backgroundSize: 'cover' }}
            />

            <div className="flex-1 w-96">
              <h4 className="text-orange-500">---- Qui sommes nous ? ----</h4>
              <h2 className="text-3xl font-bold mb-4">Chez TournoisPadel, nous partageons une passion commune : <span className='text-orange-300'> le padel.</span></h2>
              <p className="text-lg mb-6">
              L'idée est née d'une simple constatation : il est parfois difficile pour les joueurs, débutants comme confirmés, de trouver des tournois adaptés, de rencontrer des partenaires fiables et de rester informés des actualités dans ce sport en pleine expansion. 
              <br />En tant que joueuse passionnée, je me suis souvent retrouvée à chercher désespérément les bonnes informations à travers plusieurs plateformes, groupes WhatsApp ou réseaux sociaux. 
              C'est ainsi qu'est né TournoisPadel, une plateforme dédiée et pensée par une joueuse pour les joueurs.
              </p>
            </div>
            </div>
        </div>
      </section>
    );
  };

  const DoubleSection: React.FC = () => {
    return (
      <section className="py-8">
        <div className="container mx-auto px-4 w-full h-40 shadow-md rounded-lg"
        style={{ backgroundImage: `url(${imgBanniereBalle})`, backgroundSize: 'cover' }}
        >
            <div className="p-3 text-white text-xl md:text-3xl flex flex-col md:flex-row justify-between font-bold">
            <div className='relative flex-1 w-full md:w-1/3 h-96'>
              <h4 className="">Rejoignez-nous</h4>
              <h4 className="">Devenez acteur de cette belle aventure</h4>    
            </div>            
              <img src={imgDouble} className="hidden md:block flex-1 sm:h-96 relative ml-auto bottom-60 mt-14 md:mt-0" />
            </div>      
          </div>

      </section>
    );
  };

  const MissionSection: React.FC = () => {
    return (
      <section className="py-8">
        <div className="container mx-auto px-4 text-center">
          
            <div className="flex flex-col md:flex-row items-center gap-8">
            <div              
              className="p-4 rounded-lg shadow-md bg-cover bg-center h-80  w-80"
              style={{ backgroundImage: `url(${imgBulle1})`, backgroundSize: 'cover' }}
            />

            <div className="flex-1 w-96">
              <h4 className="text-orange-500">---- Notre mission ----</h4>
              <h2 className="text-3xl font-bold mb-4">Notre mission chez TournoisPadel</h2>
              <p className="text-lg mb-6">
                Notre mission est simple : faciliter l'accès aux tournois dans toute la France, rassembler la communauté des passionnés de padel et offrir un outil intuitif et complet pour ne plus jamais manquer une occasion de jouer. 
                <br />Nous croyons au pouvoir de la communauté et à la magie du padel pour rassembler. Que vous soyez un compétiteur chevronné ou un joueur occasionnel, TournoisPadel.fr est là pour vous accompagner à chaque étape.
              </p>              
            </div>
            </div>
        </div>
      </section>
    );
  };

  const PremiumModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg p-8 max-w-md w-full relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h3 className="text-2xl font-bold mb-4">Fonctionnalités Premium</h3>
          <div className="space-y-4">
            <p className="text-gray-600">
              Accédez à toutes les fonctionnalités premium avec notre abonnement :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Recherche avancée de partenaires</li>
              <li>Recevez des alertes instantanées dès qu’un nouveau tournoi est annoncé dans votre région ou selon vos critères</li>
              <li>Envoyez et recevez des messages privés directement sur la plateforme pour organiser vos matchs ou trouver un partenaire pour participer à des tournois</li>
            </ul>
            <div className="mt-6">
              <p className="px-8 py-4 text-center bg-orange-300 text-white text-lg font-medium rounded-lg  transition">5€ / mois</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const FeaturesSection: React.FC = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = sessionStorage.getItem('accessToken');
        setIsLoggedIn(!!token);
    }, []);
    
    const features = [
      {
        image: imgTournoiDispo,
        title: 'Tournois disponibles',
        link: '/tournois',
        description: 'Trouvez votre tournoi partout en France et réservez votre place sans plus attendre.',
        isPremium: false
      },
      {
        image: imgPartenaire,
        title: 'Trouvez un partenaire',
        link: isLoggedIn ? '/partenaires' : '/premium',
        description: 'Connectez-vous avec d\'autres joueurs passionnés près de chez vous.',        
        isPremium: false
      },
      {
        image: imgNotif,
        title: 'Notifications en temps réel',
        link: '/#',
        description: 'Recevez des notifications dès la sortie des tournois de vos ligues favorites.',        
        isPremium: true
      },
    ];
    const handleFeatureClick = (feature: typeof features[0]) => {
      if (feature.isPremium) {
        setIsModalOpen(true);
      } else {
        window.location.href = feature.link;
      }
    };
    return (
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h4 className="text-orange-500">---- SERVICES ----</h4>
          <h2 className="text-3xl font-bold mb-12">Ce que nous vous proposons</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
            {features.map((feature, index) => (
              
              feature.isPremium  ? (
                
                  <div onClick={() => handleFeatureClick(feature)}
                    key={index}
                    className="p-4 text-left rounded-lg shadow-md bg-cover bg-center h-64"
                    style={{ backgroundImage: `url(${feature.image})`, backgroundSize: 'cover' }}
                    >
                    <h3 className="text-xl font-semibold">{feature.title}</h3>
                    <p className="mt-2">{feature.description}</p>                                    
                  </div>                
              ) : (
                <a href={feature.link}>
                  <div
                    key={index}
                    className="p-4 text-left rounded-lg shadow-md bg-cover bg-center h-64"
                    style={{ backgroundImage: `url(${feature.image})`, backgroundSize: 'cover' }}
                    >
                    <h3 className="text-xl font-semibold">{feature.title}</h3>
                    <p className="mt-2">{feature.description}</p>                                  
                  </div>
                </a>
              )

            ))}
          </div>
        </div>
        <PremiumModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </section>
    );
  };


const Home: React.FC = () => {
  return (
    <div>      
            
      <Menu />
      
      <HeroSection />      
      
      <PartageSection />
      
      <DoubleSection />

      <MissionSection />

      {/* PremiumSection component displays the premium section of the home page */}
      <FeaturesSection />

      {/* InteractiveMap component displays the interactive map of the home page 
      <MapSection />*/}

      <PremiumSection />
      

      {/* Footer component displays the footer of the home page */}
      <Footer />  
    </div>
  );
}

export default Home;